import type { HelpDialogPluginOptions } from '@atlaskit/editor-plugin-help-dialog';

interface Props {
	options: never;
}

export function helpDialogPluginOptions({}: Props): HelpDialogPluginOptions {
	return false;
}
